module.exports = __webpack_public_path__ + "static/media/masthead-geraldton-guardian.603f14c7.svg";